import { render, staticRenderFns } from "./my-consultation.vue?vue&type=template&id=fc361538&scoped=true"
import script from "./my-consultation.vue?vue&type=script&lang=js"
export * from "./my-consultation.vue?vue&type=script&lang=js"
import style0 from "./my-consultation.vue?vue&type=style&index=0&id=fc361538&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc361538",
  null
  
)

export default component.exports